<template src="./index.html"></template>
<script>
	import {getdata} from "./data.js";
	import addzc from "../../../common/addzc/index.vue";
	import seezc from "../../../common/seezc/index.vue";
	import {
		zcfg_fycx,
		zcfg_delete,
		zcfg_fetch
	} from "../../../../api/zcfg.js";
	import config from "../../../../../configHttp.js";
	export default {
		name: "cszd",
		components: {
			addzc,
			seezc,
		},
		data: function() {
			return {
				gaojiss: false,
				wikiType: "2", //页面
				tablekey: 0,
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				outlist: [],
				headData: getdata().headData,
				pagination: getdata().pagination,
				search: [],
				tableData: [],
				shaidiag: false,
				searchdiag: false,
				zcdiag: false,
				seezcdiag: false,
				formlist: getdata().formlist,
				seezcformlist: getdata().seezcformlist,
				seezcformdata: null,
				xinzxg: null,
				sskuang: "",
				chushuaformdata: {
					id: "",
					policyTitle: "",
					isValid: "2",
					policyType: "1",
					fbDanw: "",
					policyNum: "",
					xianggxz: "1",
					fabTime: "",
					implementTime: "",
					originalLink: "",
					policyDesc: "",
					policyFileList: [],
					policyList: [],
					wikiType: "",
          openRule: "1",
					zhongycd:'',
					remark:'',
					tagIds:[],
				},
				//跳转数据
				formdata: getdata().formdata, //form表单数据
				// originalLink: "", //源文件链接
				// content: "", //文本框数据
				fbkyuwduixi: {
					originalLink: "",
					content: ""
				}, //源文件链接文本框数据
				zclist: [], //政策
				upformdataadd: [], //文件
			};
		},

		mounted() {
		
		},
		created() {
			this.fetchResultShow();
			this.keyupSubmit();
		},
		methods: {
			keyupSubmit() {
				document.onkeydown = e => {
					let _key = window.event.keyCode;
					//!this.clickState是防止用户重复点击回车
					if (_key === 13 && !this.clickState) {
						this.shoshuokuangss();
					}
				};
			},
			shoshuokuangss() {
				this.pagination.pageNum = 1;
				let params = {
					searchKey: this.sskuang,
					wikiType: this.wikiType
				};
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = "";
				params.order = "";
				zcfg_fycx(params).then((res) => {
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
				});
			},
			gaojichaxun() {
				this.pagination.pageNum = 1;
				this.formdata.wikiType = this.wikiType;
				let params = this.formdata;
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = "";
				params.order = "";

				zcfg_fycx(params).then((res) => {
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
					this.gaojiss = false;
				});
			},
			// 查询进行发票合计结果(分页)
			fetchResultShow() {
				let params = {};
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.sort = "";
				params.order = "";
				params.wikiType = this.wikiType;
				zcfg_fycx(params).then((res) => {
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
				});
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.fetchResultShow();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.fetchResultShow();
			},
			forRefresh() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.fetchResultShow();
			},
			closediag() {
				this.zcdiag = false;
			},
			bianjitankuang(e) {
				let params = {};
				params.id = e.id;
				zcfg_fetch(params).then((res) => {
					if (res.data.code == 1) {
						this.formdata = res.data.data;
						this.formdata.id = e.id;
						// this.originalLink = res.data.data.originalLink;
						// this.content = res.data.data.policyDesc;
						this.zclist = res.data.data.policyList;
						this.fbkyuwduixi = {
							originalLink: res.data.data.originalLink,
							content: res.data.data.policyDesc,
						};
						this.upformdataadd = res.data.data.policyFileList.map((item) => {
							return {
								upfilename: item.filePrefix + item.fileSuffix,
								suoming: item.fileDesc,
								policyFileList: item.id,
							};
						});
						this.zcdiag = true;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			confirmfilter() {},
			closeshaidiag() {},
			getdata(e) {

			},
			rTime(date) {
				var time = new Date(date);
				var y = time.getFullYear();
				var m = time.getMonth() + 1;
				var d = time.getDate();
				var h = time.getHours();
				var mm = time.getMinutes();
				var s = time.getSeconds();
				return y + '-' + this.add0(m) + '-' + this.add0(d)  ;
			},
			add0(m) {
				return m < 10 ? '0' + m : m;
			},
			chakangxx(e) {
				let params = {};
				params.id = e.id;
				zcfg_fetch(params).then((res) => {
					if (res.data.code == 1) {
						if (res.data.data.fabTime != null && res.data.data.fabTime != '') {
							res.data.data.fabTime = this.rTime(res.data.data.fabTime);
						}
						if (res.data.data.implementTime != null && res.data.data.implementTime != '') {
							res.data.data.implementTime = this.rTime(res.data.data.implementTime);
						}
						this.formdata = res.data.data;
						this.formdata.id = e.id;
						this.zclist = res.data.data.policyList;
						this.fbkyuwduixi = {
							originalLink: res.data.data.originalLink,
							content: res.data.data.policyDesc,
						};
						this.upformdataadd = [];
						res.data.data.policyFileList.forEach((element) => {
							let zhancui = {
								upfilename: element.filePrefix + element.fileSuffix,
								suoming: element.fileDesc,
								policyFileList: element.id,
								fileUrl: element.fileUrl,
							};
							this.upformdataadd.push(zhancui);
						});
						this.seezcdiag = true;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			zhengcxingz() {
				this.formdata = JSON.parse(JSON.stringify(this.chushuaformdata));
				// this.originalLink = "";
				// this.content = "";
				this.fbkyuwduixi = {
					originalLink: "",
					content: ""
				};
				this.zclist = [];
				this.upformdataadd = [];
				this.zcdiag = true;
			},
			closeseezcdiag() {
				this.seezcdiag = false;
			},
			fordelete() {
				var chooseitem = this.$refs.tablebox.getSelectionval();
				if (this.$emptyandnull(chooseitem)) {
					this.$message.error("请选择数据");
					return false;
				}
				let params = {
					wikiInfo: chooseitem.map((v) => v.id),
				};

				this.$showConfirm({
					message: "确认删除?",
				}).then((res) => {
					if (res == "confirm") {
						zcfg_delete(params).then((res) => {
							if (res.data.code == 1) {
								this.$message.success("删除成功");
								this.pagination.pageNum = 1;
								this.pagination.paginationkey++;
								this.fetchResultShow();
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			},
			changeUpformdataadd(e) {
				this.upformdataadd = e;
			},

			jiesbaocfh(v) {
				if (v) {
					this.zcdiag = false;
					this.fetchResultShow();
				}
			},
			openSerach() {
				this.$nextTick(() => {
					this.$refs.taxform.clearValidate();
				});
				this.formdata = JSON.parse(JSON.stringify(this.chushuaformdata));
				this.gaojiss = true;
			},
			cannelSearch() {
				this.gaojiss = false;
			},
			// 导出进项发票合计结果
			exportExcel() {
				let selectVal = this.$refs.tablebox.getSelectionval();

				let idList = [];
				if (selectVal.length > 0) {
					idList = selectVal.map((item) => item.id);
				}
				let date = {
					idList: idList,
					wikiType: this.wikiType,
				};
				let params = {
					downUrl: config.baseURL + "wiki/policy/export",
					typeObj: {
						toForm: false,
						fileName: "财税制度" + this.$timestampToStr(new Date(), "yyyyMMdd"),
						fileType: "xlsx",
						failUrl:this.$winURl,

					},
					params: date,
				};
				this.$downloadcommon(params);
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
